const socialIcons = document.getElementById('component--social-icons')
socialIcons.style.display = 'none'

var swipe2 = new Swiper(".mySwiper4", {
  slidesPerView: 1,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
});


function animateSVG() {
  anime({
    targets: '.svg-path-animate path',
    strokeDashoffset: [anime.setDashoffset, 0],
    easing: 'easeInOutSine',
    duration: 2000,
    delay: 0,
    loop: false
  });

  anime({
    targets: '.svg-path-animate',
    opacity: 1,
    easing: 'easeInOutSine',
    duration: 1000,
    delay: 0,
    loop: false
  });

}

const SVGSToBeAnimated = document.querySelectorAll('.svg-path-animate')
SVGSToBeAnimated.forEach(svg => {
  gsap.to(svg, {
    scrollTrigger: {
      trigger: svg,
      start: "top 90%",
    },
    onComplete: () => animateSVG()
  });
})

const mainImage = document.getElementById("main-image")
const secundaryImage = document.querySelectorAll(".secundary-image")
secundaryImage.forEach(image => {
  image.addEventListener('click', () => {
    const src = image.getAttribute("src")
    mainImage.setAttribute('src', src)
  })
})


let zoomImg = document.querySelector(".f-panzoom");
const options = {
  panMode: "mousemove",
  mouseMoveFactor: 3,
  click: false,
  wheel: false
};

const fp = new Panzoom(zoomImg, options);

zoomImg.addEventListener('mouseenter', () =>{
  fp.zoomTo(3)
});

zoomImg.addEventListener('mouseleave', () =>{
  fp.zoomToFit()
});

